export function defer() {
    let fns
    const result = new Promise(function (resolve, reject) {
        fns = { resolve, reject }
    })
    result.promise = result
    Object.assign(result, fns)
    return result
}
